import { mount } from 'svelte';
import PublicApp from '@/components/public/PublicApp.svelte';

const target = document.getElementById('public-app');

if (target) {
	const pageType = target.dataset.page ?? 'terms';
	const uuid = target.dataset.uuid ?? '';
	const stripeKey = target.dataset.stripeKey ?? '';

	let plans = [];
	if (target.dataset.plans) {
		try {
			plans = JSON.parse(target.dataset.plans);
		} catch {
			plans = [];
		}
	}

	mount(PublicApp, {
		target,
		props: {
			pageType,
			uuid,
			stripeKey,
			plans,
		},
	});
}
